export default __webpack_public_path__ + "static/media/about-hero.d1fb44c9.png";